import { render } from "./ClientPersonalListado.vue?vue&type=template&id=0e522e1d"
import script from "./ClientPersonalListado.vue?vue&type=script&lang=js"
export * from "./ClientPersonalListado.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__